import { render, staticRenderFns } from "./StandardMessage.vue?vue&type=template&id=784b72fe&scoped=true&"
import script from "./StandardMessage.vue?vue&type=script&lang=ts&"
export * from "./StandardMessage.vue?vue&type=script&lang=ts&"
import style0 from "./StandardMessage.vue?vue&type=style&index=0&id=784b72fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784b72fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VImg,VSpacer})
